module.exports = __webpack_public_path__ + "2c90f50c6975a5db74863741013288b9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-webfont.woff
// module id = 405
// module chunks = 0